// src/services/user-service.js
import api from "@/services/api";

export default {
  // User Authentication
  login(data) {
    return api.post("/auth/login", data);
  },

  logout() {
    return api.post("/auth/logout");
  },

  forgotPassword(email) {
    return api.post("/auth/password-reset", email);
  },

  resetPassword(data) {
    return api.post("/auth/password-create", data);
  },

  // Fetch user profile
  getUserProfile() {
    return api.get("/auth/profile");
  },

  // Nouvelle méthode pour récupérer le profil d'un utilisateur spécifique
  getUserProfileById(userId) {
    return api.get(`/users/${userId}/profile`);
  },

  // Update user profile
  updateUserProfile(data) {
    return api.put("/auth/profile", data);
  },

  // Change user password
  changePassword(data) {
    return api.patch("/auth/password", data);
  },
};
